import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Input, InputGroup, InputGroupAddon, Button, Table } from 'reactstrap';
import moment from 'moment';

import actions from './actions';

class ListaPerfis extends Component {
  constructor (props) {
    super(props);

    this.state = {
      filtro: {
        usuario: "",
        perfil: ""
      }
    };
  }

  componentDidMount() {
    this.props.actions.onLoadTodasTarefasConfigPerfis();
  }

  handleSelect = ({ target: { name, value } }) => this.setState(({ filtro }) => ({
    filtro: {
      ...filtro,
      [name]: value
    }
  }));

  handleFiltro = ({ target: { name, value } }) => this.setState(({ filtro }) => ({
    filtro: {
      ...filtro,
      [name]: value.toUpperCase().replace(/\W+/g, "")
    }
  }));

  updatePerfil = e => {
    const { filtro } = this.state;
    
    if (this.isValid()) {
      this.props.actions.updatePerfil(filtro)
      .then(() => this.props.actions.onLoadTodasTarefasConfigPerfis());
    }
  };

  isValid = () => {
    const { usuario } = this.state.filtro;
    const { usuarios } = this.props.value.result;

    return usuarios.some(u => u.id === parseInt(usuario, 10));
  };

  render () {
    const { value: { result: { perfis, usuarios } } } = this.props;
    const { filtro: { usuario, perfil } } = this.state;

    return (<Table size="sm">
      <thead>
        <tr>
          <th>Usuário</th>
          <th>Perfil</th>
        </tr>
        <tr>
          <th><Input type="select" value={usuario} name="usuario" onChange={this.handleSelect}>
            <option disabled value=""></option>
            {usuarios.map(usuario => (<option key={usuario.id} value={usuario.id}>{usuario.nome}</option>))}
          </Input></th>
          <th><InputGroup>
            <Input name="perfil" value={perfil} onChange={this.handleFiltro} />
            <InputGroupAddon addonType="append"><Button disabled={!this.isValid()} color="success" onClick={this.updatePerfil}><span className="fa fa-plus"></span></Button></InputGroupAddon>
          </InputGroup></th>
        </tr>
      </thead>
      <tbody>
        {perfis.map(perfil => (<tr key={perfil.id}>
          <td>{perfil.nome_usuario}</td>
          <td>{perfil.nome}<br />{perfil.created_at?moment(perfil.created_at).calendar():""}</td>
        </tr>))}
      </tbody>
    </Table>);
  }
}

let mapStateToProps = ({ agenda }) => ({
  value: agenda.config_perfis
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaPerfis);


// WEBPACK FOOTER //
// ./src/modules/agenda/ListaPerfis.js